var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total_search"},[_c('div',{staticClass:"fixed"},[_c('Head',{attrs:{"type":"back","name":"search","title":"스탬프 검색"}}),_c('SearchBar'),_c('SearchResultFilter')],1),_c('div',{staticClass:"search_a"},[_c('SearchResult'),_c('PopupMyStamp')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }